import { proxy } from 'valtio';

// Permission enums
export const PermissionAction = {
  CREATE: "CREATE",
  READ: "READ",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  EXPORT: "EXPORT",
  NOTIFICATION: "NOTIFICATION",
};
export const ResourceType = {
  COURSE: "COURSE",
  TOPIC: "TOPIC",
  LEARNING_MATERIAL: "LEARNING_MATERIAL",
  TEST: "TEST",
  USER: "USER",
  ANALYTICS: "ANALYTICS",
  NOTIFICATION: "NOTIFICATION",
  SUPPORT_TICKET: "SUPPORT_TICKET",
  ALL: "*",
};
// Default role-based permissions (should match backend constants)
const rolePermissions = {
  SEAFARER: {
    [PermissionAction.READ]: [
      ResourceType.COURSE,
      ResourceType.TOPIC,
      ResourceType.LEARNING_MATERIAL,
      ResourceType.TEST,
      ResourceType.USER,
    ],
    [PermissionAction.UPDATE]: [ResourceType.USER],
    [PermissionAction.CREATE]: [ResourceType.SUPPORT_TICKET],
  },
  ADMIN: {
    [PermissionAction.READ]: [
      ResourceType.COURSE,
      ResourceType.TOPIC,
      ResourceType.LEARNING_MATERIAL,
      ResourceType.TEST,
      ResourceType.USER,
      ResourceType.ANALYTICS,
      ResourceType.SUPPORT_TICKET,
    ],
    [PermissionAction.CREATE]: [],
    [PermissionAction.UPDATE]: [],
    [PermissionAction.DELETE]: [],
    [PermissionAction.EXPORT]: [],
    [PermissionAction.NOTIFICATION]: [],
  },
  SUPER_ADMIN: {
    [PermissionAction.CREATE]: [ResourceType.ALL],
    [PermissionAction.READ]: [ResourceType.ALL],
    [PermissionAction.UPDATE]: [ResourceType.ALL],
    [PermissionAction.DELETE]: [ResourceType.ALL],
    [PermissionAction.EXPORT]: [ResourceType.ALL],
    [PermissionAction.NOTIFICATION]: [ResourceType.ALL],
  },
};

export const permissionStore = proxy({
  role: 'SEAFARER', // default
  permissions: rolePermissions['SEAFARER'],
  setRole(role) {
    permissionStore.role = role;
    permissionStore.permissions = rolePermissions[role] || {};
  },
  setPermissions(permissions) {
    permissionStore.permissions = permissions || {};
  },
  /**
   * Checks if the user has the given action on the resource.
   * @param {string} action
   * @param {string} resource
   * @returns {boolean}
   */
  can(action, resource) {
    const perms = permissionStore.permissions?.[action];
    if (!perms) return false;
    return perms.includes(ResourceType.ALL) || perms.includes(resource);
  },
});
